import {createAction} from "@reduxjs/toolkit";

export const productSearchToggleFiltersAction = createAction('productSearchToggleFilters');